import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { SWReactIcons } from "@similarweb/icons";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { withSWReactIconFillColor } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/common-styles";

export const StyledModalFinalStep = styled(FlexColumn)``;

export const StyledIconWrapper = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
`;

const StyledIntentModalContentWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    text-align: center;
`;

export const StyledFinalStepModalTitle = styled(StyledIntentModalContentWrapper)`
    ${mixins.setFontVariant("h6", colorsPalettes.carbon["500"])};
    margin: 8px 0;
`;

export const StyledIntentModalLinkWrapper = styled(StyledIntentModalContentWrapper)`
    margin-top: 16px;
`;

export const StyledFinalStepModalDescription = styled.div`
    display: inline;
    width: 100%;
    justify-content: center;
    text-align: center;
    align-items: center;
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["400"])};
    margin-bottom: 32px;
`;

export const StyledApplyDataAgreementsText = styled(StyledFinalStepModalDescription)`
    margin-bottom: 20px;
`;

export const StyledFinalStepModalSubDescription = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    text-align: center;
    align-items: center;
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["400"])};
    margin-bottom: 20px;
`;

export const StyledFinalStepModalBtnWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
`;

export const StyledUserApproveLink = styled.a`
    ${mixins.setFontVariant("button", colorsPalettes.blue["400"])};
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 16px;
    justify-content: center;
`;

export const StyledUserApproveIcon = styled(SWReactIcons)`
    margin-left: 4px;

    & svg path {
        fill: ${colorsPalettes.blue["400"]};
        fill-opacity: 1;
        stroke: none;
    }
`;

export const StyledModalErrorContainer = styled(FlexColumn)`
    width: 100%;
`;

export const StyledModalErrorTitleContainer = styled(FlexRow)`
    margin-bottom: 36px;
`;

export const StyledModalErrorTitle = styled.div`
    display: flex;
    align-items: center;
    ${mixins.setFontVariant("h5_2", colorsPalettes.carbon["500"])};
`;
export const StyledModalIconWrapper = styled.div`
    ${withSWReactIconFillColor(colorsPalettes.red["400"])};
    margin-right: 8px;
`;

export const StyledModalErrorDescription = styled.div`
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["400"])};
    padding-right: 40px;
    margin-bottom: 28px;
`;

export const StyledModalErrorCTAWrapper = styled.div`
    display: flex;
    width: 100%;
    align-items: flex-end;
    justify-content: flex-end;
`;
